module.exports = __webpack_public_path__ + "static/media/zheng10@2x.df8ebef1.png";